import { createSelector } from '@ngrx/store';
import { selectUser } from './user.selectors';
import { UserPermission } from '../models/user-permission.enum';
import { memoize } from 'lodash';

const userPermissionSeparator = ':';

export const selectUserPermissions = createSelector(selectUser, user => user?.authorization.permissions ?? []);

const selectUserPermissionPolicies = createSelector(selectUser, user => user?.authorization?.permissionPolicies ?? []);

const selectUserPermissionPoliciesByDomainAndEntityName = memoize((domain: string, entityName: string) => createSelector(
  selectUserPermissionPolicies,
  permissionPolicies => permissionPolicies.filter(pp => pp.domain === domain && pp.entityName === entityName)
), memoizeByDomainAndEntityName);

export const selectUserHasPermission = memoize((userPermission: UserPermission) => {
  const [domain, entityName, action] = userPermission?.split(userPermissionSeparator) ?? [];

  return createSelector(
    selectUserPermissionPoliciesByDomainAndEntityName(domain, entityName),
    policies => policies.some(policy => policy.actionSet?.includes(action))
  );
});

function memoizeByDomainAndEntityName(domain: string, entityName: string): string {
  return `${domain}:${entityName}`;
}
